<template>
  <div class="footer" inset app>
    <LowAvailableBalanceFooter />
    <TrialFooter />
  </div>
</template>

<script>
import LowAvailableBalanceFooter from './LowAvailableBalanceFooter'
import TrialFooter from './TrialFooter'

/**
 * The fixed strip at the bottom-left that carries the account notices.
 *
 * It owns the positioning and the row layout, nothing else. Each pill decides on its own whether it
 * is drawn, so one of them going quiet never takes the other down with it — the strip itself has no
 * background or padding, so an empty one is invisible.
 */
export default {
  name: 'FooterNotices',

  components: {
    LowAvailableBalanceFooter,
    TrialFooter,
  },
}
</script>
